import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { TextField } from '@mui/material'

const Input = ({
  control,
  name,
  rules,
  id,
  placeholder,
  type = 'text',
  block = false,
  disabled,
  normalizers,
  onValueChange,
  slotProps: customSlotProps,
  ...textFieldProps
}) => {
  const fieldId = id ?? name

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          id={fieldId}
          name={field.name}
          fullWidth={block}
          label={placeholder}
          type={type}
          margin='normal'
          value={field.value ?? ''}
          inputRef={field.ref}
          onBlur={field.onBlur}
          onChange={(event) => {
            const raw = event.target.value
            const value = normalizers
              ? normalizers.reduceRight((current, normalize) => normalize(current), raw)
              : raw
            field.onChange(value)
            onValueChange?.(value)
          }}
          error={fieldState.invalid}
          helperText={fieldState.error?.message}
          slotProps={{
            ...customSlotProps,
            input: {
              ...customSlotProps?.input
            },
            htmlInput: {
              'data-testid': `test-${fieldId}`,
              disabled,
              style: { color: disabled ? 'gray' : 'inherit' },
              ...customSlotProps?.htmlInput
            },
            formHelperText: {
              'data-testid': `test-${fieldId}-helper-text`,
              ...customSlotProps?.formHelperText
            }
          }}
          {...textFieldProps}
        />
      )}
    />
  )
}

Input.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  normalizers: PropTypes.array,
  onValueChange: PropTypes.func
}

export default Input
